@if (variant() === "chevron") {
  @if (direction() === "right") {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="rtl:rotate-180">
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  } @else {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="rtl:rotate-180">
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  }
} @else {
  @if (direction() === "right") {
    <svg class="h-7 w-4 rtl:-scale-x-100" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        class="fill-primary"
        d="M19.5347 16.3443L2.8157 0.414285C2.53674 0.148351 2.16611 -7.79544e-07 1.7807 -7.96391e-07C1.39529 -8.13238e-07 1.02467 0.148351 0.745705 0.414285L0.727703 0.432285C0.591999 0.561205 0.48394 0.716384 0.410099 0.888383C0.336258 1.06038 0.298178 1.2456 0.298178 1.43278C0.298178 1.61996 0.336258 1.80519 0.410099 1.97719C0.48394 2.14919 0.591999 2.30436 0.727703 2.43328L16.4717 17.4333L0.727702 32.4273C0.591998 32.5562 0.483939 32.7114 0.410098 32.8834C0.336256 33.0554 0.298176 33.2406 0.298176 33.4278C0.298176 33.615 0.336256 33.8002 0.410098 33.9722C0.483939 34.1442 0.591998 34.2993 0.727702 34.4283L0.745703 34.4463C1.02467 34.7122 1.39529 34.8606 1.7807 34.8606C2.16611 34.8606 2.53674 34.7122 2.8157 34.4463L19.5347 18.5163C19.6817 18.3762 19.7988 18.2077 19.8788 18.021C19.9588 17.8343 20 17.6334 20 17.4303C20 17.2272 19.9588 17.0262 19.8788 16.8395C19.7988 16.6529 19.6817 16.4844 19.5347 16.3443Z" />
    </svg>
  } @else {
    <svg class="h-7 w-4 rtl:-scale-x-100" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        class="fill-primary"
        d="M0.465303 18.6557L17.1843 34.5857C17.4633 34.8517 17.8339 35 18.2193 35C18.6047 35 18.9753 34.8517 19.2543 34.5857L19.2723 34.5677C19.408 34.4388 19.5161 34.2836 19.5899 34.1116C19.6637 33.9396 19.7018 33.7544 19.7018 33.5672C19.7018 33.38 19.6637 33.1948 19.5899 33.0228C19.5161 32.8508 19.408 32.6956 19.2723 32.5667L3.5283 17.5667L19.2723 2.57273C19.408 2.44381 19.5161 2.28863 19.5899 2.11663C19.6637 1.94463 19.7018 1.75941 19.7018 1.57223C19.7018 1.38505 19.6637 1.19983 19.5899 1.02783C19.5161 0.85583 19.408 0.700652 19.2723 0.57173L19.2543 0.553729C18.9753 0.287795 18.6047 0.139441 18.2193 0.139441C17.8339 0.139441 17.4633 0.287794 17.1843 0.553728L0.465303 16.4837C0.318266 16.6238 0.201209 16.7923 0.121227 16.979C0.0412445 17.1657 2.31234e-06 17.3666 2.28571e-06 17.5697C2.25907e-06 17.7728 0.0412444 17.9738 0.121227 18.1605C0.201209 18.3471 0.318266 18.5156 0.465303 18.6557Z" />
    </svg>
  }
}
